import {
  DescriptionSkeleton,
  HeaderSkeleton,
  InputContainer,
  InputSkeleton,
  MainContainer,
  PromptContainer,
  PromptsContainer,
  SkeletonBar,
  SkeletonBarHolder,
  SkeletonBarTop,
} from "./style";

const ChatbotSkeleton = () => {
  return (
    <MainContainer>
      <SkeletonBarTop>
        <SkeletonBarHolder className="small">
          <SkeletonBar />
        </SkeletonBarHolder>
        <SkeletonBarHolder className="small">
          <SkeletonBar />
        </SkeletonBarHolder>
        <SkeletonBarHolder>
          <SkeletonBar />
        </SkeletonBarHolder>
        <SkeletonBarHolder>
          <SkeletonBar />
        </SkeletonBarHolder>
      </SkeletonBarTop>
      <SkeletonBarHolder className="edit">
        <SkeletonBar />
      </SkeletonBarHolder>
    </MainContainer>
  );
};

export default ChatbotSkeleton;
